import * as api from './adapter';

// Vacancy-flow settings (CREW-1217). Talks to planvisor's plain-JSON
// `vacancies/settings` endpoint (not JSON:API), so the response is the object
// the BE renders — unwrap the adapter's { data, headers } the same way
// `recruitingMetrics` does.
const unwrap = (promise) => promise.then((res) => res.data);

export default {
  /**
   * Current settings plus `editable`, which says whether this user may write
   * them. The BE enforces the same permission; `editable` only decides
   * whether we render an editor or a read-only line.
   * @returns {Promise<Object>}
   */
  get: () => unwrap(api.read('vacancies/settings')),

  /**
   * @param {Object} attributes - e.g. { assignment_reset_days: 1 }
   * @returns {Promise<Object>} the stored settings
   */
  update: (attributes) =>
    unwrap(api.update({ controller: 'vacancies/settings', ...attributes })),
};
